/** @format */

import { takeLatest } from "redux-saga/effects";
import { TActionType } from "../declarations/actionTypes";
import { sagaAccountTypeList } from "../sagas/sagasAccountType";

export function* watcherAccountType(): unknown {
  yield takeLatest(TActionType.accountTypeListRequest, sagaAccountTypeList);
}
